module.exports = __webpack_public_path__ + "static/media/timer_off.d3de4d93.png";